import { gql } from '@apollo/client';

import { PageFields } from '../fragments';

const SUBSCRIBE_TO_PAGE_UPDATE = gql`
  subscription OnPageUpdated($id: String!, $type: String!) {
    pageUpdated(id: $id, type: $type) {
      __typename
      ...PageFields
    }
  }
  ${PageFields}
`;

const SUBSCRIBE_TO_BLOCK_DETECTED = gql`
  subscription OnBlockDetected($chain: String!) {
    blockDetected(chain: $chain) {
      __typename
      blockNumber
      chain
    }
  }
`;

export { SUBSCRIBE_TO_PAGE_UPDATE, SUBSCRIBE_TO_BLOCK_DETECTED };
